/* wishlist.js - cross-device + multi-device safe */
(function () {
  'use strict';

  const LOG = true;
  const log = (...a) => { if (LOG) console.log('[Wishlist]', ...a); };
  const warn = (...a) => { if (LOG) console.warn('[Wishlist]', ...a); };
  const err = (...a) => { if (LOG) console.error('[Wishlist]', ...a); };
  function safe(fn) { try { return fn(); } catch(e) { err('Erreur interne:', e); } }

  const CUSTOMER_KEY = window.customerEmail
    ? window.customerEmail.toLowerCase()
    : 'guest';

  const LS_KEY = `lpb_wishlist__${CUSTOMER_KEY}`;
  const LS_UPDATED_KEY = `lpb_wishlist_updated_at__${CUSTOMER_KEY}`;

  const ICON_EMPTY = "https://cdn.shopify.com/s/files/1/0740/8523/6952/files/icone-coeur-vide-la-petite-rebelle.png?v=1763837771";
  const ICON_FULL  = "https://cdn.shopify.com/s/files/1/0740/8523/6952/files/icone-coeur-plein-la-petite-rebelle.png?v=1763837781";

  let wishlist = [];
  let wishlistUpdatedAt = 0;
  window.customerWishlist = window.customerWishlist || [];

  // --- localStorage helpers ---
  function readLocal() {
    try {
      const list = JSON.parse(localStorage.getItem(LS_KEY) || '[]');
      const updated = parseInt(localStorage.getItem(LS_UPDATED_KEY)) || 0;
      return { list, updated };
    } catch(e) { return { list: [], updated: 0 }; }
  }

  function writeLocal(list, updated) {
    try {
      localStorage.setItem(LS_KEY, JSON.stringify(Array.from(new Set(list))));
      localStorage.setItem(LS_UPDATED_KEY, updated.toString());
    } catch(e){ warn('Impossible d\'écrire localStorage', e); }
  }

  // --- fetch serveur Vercel ---
  async function fetchServerWishlist() {
    if (!window.isCustomerLoggedIn) return { list: [], updated: 0 };
    try {
      const resp = await fetch('/pages/wishlist-json');
      if (!resp.ok) return { list: [], updated: 0 };
      const data = await resp.json();

      let handles = [];
      const raw = data.metafields?.wishlist?.handles;
      if (typeof raw === "string") {
        try { handles = JSON.parse(raw); } catch(e) { handles = []; }
      } else if (Array.isArray(raw)) {
        handles = raw;
      }

      const updated = typeof data.metafields?.wishlist?.updated_at === "string"
        ? parseInt(data.metafields.wishlist.updated_at)
        : (data.metafields?.wishlist?.updated_at || 0);

      return { list: handles, updated };
    } catch(e) {
      err('Erreur fetch server wishlist:', e);
      return { list: [], updated: 0 };
    }
  }

  // --- sync intelligent ---
  async function syncWishlist() {
    const server = await fetchServerWishlist();
    const local = readLocal();

    if (server.updated > local.updated) {
      wishlist = server.list;
      wishlistUpdatedAt = server.updated;
      writeLocal(wishlist, wishlistUpdatedAt);
      log('Wishlist synchronisée depuis le serveur');
    } else {
      wishlist = local.list;
      wishlistUpdatedAt = local.updated;
      log('Wishlist locale utilisée (plus récente ou égale)');
    }

    log('[Wishlist] localStorage mis à jour de sync', { wishlist, updatedAt: wishlistUpdatedAt }); // Affiche un log dans la console

    window.customerWishlist = wishlist;
    syncWishlistButtons();
    updateWishlistBlock();
  }

  // --- icônes ---
  function updateButtonIcon(btn) {
    safe(() => {
      if (!btn) return;
      const handle = btn.dataset?.handle;
      if (!handle) return;
      const img = btn.querySelector('img');
      const isInWishlist = wishlist.includes(handle);
      if (img) img.src = isInWishlist ? ICON_FULL : ICON_EMPTY;
      else btn.classList.toggle('in-wishlist', isInWishlist);
    });
  }

  function updateButtonText(btn) {
    safe(() => {
      if (!btn) return;
      const handle = btn.dataset?.handle;
      if (!handle) return;

      const textSpan = btn.querySelector('.wishlist-text');
      const isInWishlist = wishlist.includes(handle);

      if (textSpan) {
        const newText = isInWishlist ? 'Ajouté ✔' : 'Ajouter à la wishlist';
        // ⚡ ne mettre à jour que si c'est différent
        if (textSpan.textContent !== newText) {
          textSpan.textContent = newText;
        }
      }
    });
  }



  function syncWishlistButtons() {
    safe(() => {
      document.querySelectorAll('.wishlist-button').forEach(btn => {
        updateButtonIcon(btn);
        updateButtonText(btn);
      });
    });
  }


  // --- dashboard ---
  function updateWishlistBlock() {
    safe(() => {
      const container = document.getElementById('wishlist-block-content');
      if (!container) return;

      if (!wishlist || wishlist.length === 0) {
        return;
      }

      const products = window.WISHLIST_PRODUCTS || {};

      // Choix des produits selon la page
      const isAccountPage = window.location.pathname.startsWith('/account');
      const handlesToShow = isAccountPage
        ? wishlist.slice(-3).reverse()      // 2 derniers produits seulement
        : wishlist.slice().reverse();       // tous les produits pour le reste du site

      container.innerHTML = handlesToShow.map(handle => {
        const p = products[handle] || { url:'#', img:"https://cdn.shopify.com/s/files/1/0740/8523/6952/files/icone-coeur-vide-la-petite-rebelle.png?v=1763837771", title:'Produit inconnu' };
        return `
          <div class="wishlist-item" data-handle="${handle}" style="display:flex; gap:10px; margin:10px 0; padding:10px;align-items:center;transition: transform 0.3s ease, width 0.3s ease;">
            <a href="${p.url}" class="mobile-margin-top"><img src="${p.img}" width="60" height="60" style="border-radius:6px;"></a>
            <a href="${p.url}" class="link-item" style="font-weight:500; color:#000;margin:10px 0; padding:10px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;min-width:0;">${p.title}</a>
            <div class="delete-btn-cross" style="align-self:center; justify-self:flex-end;margin-left:auto;">
              <button class="delete-btn-x" style="border: none; background-color: unset; font-size: 20px; font-weight: bold;color:#000;">X</button>
            </div>
            <div class="delete-slide" style="display:none; flex-grow: 1;height:100%,width:100%;align-self:normal;">
              <button class="delete-btn-slide" style="height:100%; width:100%; color:#fff; background-color:#FC3C34; border:none;">Supprimer</button>
            </div>
          </div>
          `;
      }).join('');

      // Ajout de l'écouteur de clic pour chaque bouton X
      const deleteBtns = document.querySelectorAll('.delete-btn-x');
      deleteBtns.forEach(btn => {
        btn.addEventListener('click', function(e) {
          // Trouver le parent qui contient le bouton
          const wishlistItem = e.target.closest('.wishlist-item');
          const deleteSlide = wishlistItem.querySelector('.delete-slide');
          const productLinks = wishlistItem.querySelectorAll('a');  // Sélectionner tous les liens du produit
          const LinkItem = e.target.closest('.link-item');

          // Animation de glissement : déplacer l'élément de droite à gauche
          wishlistItem.style.transition = 'transform 0.3s ease'; // Assurer la fluidité de l'animation
          wishlistItem.style.transform = 'translateX(-5%)';

          // Ajouter une largeur de 108% si le bouton "X" est cliqué
          wishlistItem.style.width = '106%';

          // Affichage du bouton Supprimer
          deleteSlide.style.display = 'block';
          e.target.style.display = 'none'; // Cacher le bouton X spécifique

          // Désactiver tous les liens produits pendant que le bouton "Supprimer" est affiché
          if (deleteSlide.style.display === 'block' && productLinks.length > 0) {
            productLinks.forEach(link => {
              link.style.pointerEvents = 'none'; // Désactiver chaque lien
            });
          }

          // Optionnel : tu peux aussi ajouter une animation pour un effet plus fluide
          setTimeout(() => {
            deleteSlide.style.opacity = 1; // Rendre le bouton "Supprimer" visible
          }, 300); // L'animation de translation dure 0.3s, donc après ce délai, on affiche le bouton "Supprimer"
        });
      });

      // Écouter les clics globaux pour réinitialiser
      document.body.addEventListener('click', function(e) {
        const wishlistItem = e.target.closest('.wishlist-item'); // Trouve l'élément .wishlist-item cliqué
        if (!wishlistItem) return; // Si on clique en dehors de .wishlist-item, on arrête

        const deleteSlide = wishlistItem.querySelector('.delete-slide');  // Cibler le delete-slide spécifique à chaque wishlistItem
        const deleteBtn = e.target.closest('.delete-btn-x'); // Si on clique sur le bouton X
        const deleteBtnSlide = e.target.closest('.delete-btn-slide'); // Si on clique sur le bouton "Supprimer"
        const productLinks = wishlistItem.querySelectorAll('a');  // Le lien du produit

        // Vérifie si le clic est en dehors du produit, du bouton "X", et du bouton "Supprimer"
        if (!deleteBtn && !deleteBtnSlide && deleteSlide && !deleteSlide.contains(e.target)) {
          // Réinitialiser la translation du produit avec animation inverse
          wishlistItem.style.transition = 'transform 0.3s ease'; // Animation de retour
          wishlistItem.style.transform = '';  // Retirer la translation, remettre à sa position initiale
          wishlistItem.style.width = '100%';

          // Cacher le bouton "Supprimer" et afficher de nouveau le bouton "X"
          if (deleteSlide) {
            deleteSlide.style.display = 'none'; // Cacher le bouton "Supprimer"
          }

          const xBtn = wishlistItem.querySelector('.delete-btn-x');
          if (xBtn) {
            xBtn.style.display = 'block';  // Réafficher le bouton "X"
          }

          // Réactiver le lien du produit lorsque l'animation est terminée
          setTimeout(() => {
            if (productLinks.length > 0) {
              productLinks.forEach(link => {
                link.style.pointerEvents = ''; // Réactiver chaque lien
              });
            }
          }, 300);  // Réactiver après l'animation de retour du produit
        }
      }, true);  // Utilisation de la phase de capture pour détecter plus tôt

      // 🔥 NOUVEAU : Fermer tous les slides si clic en dehors des wishlist-item et delete-btn-slide
      document.body.addEventListener('click', function(e) {

        const clickedInsideItem = e.target.closest('.wishlist-item');
        const clickedDeleteSlideBtn = e.target.closest('.delete-btn-slide');

        // Si on clique ailleurs que sur un wishlist-item ET ailleurs que sur le bouton supprimer
        if (!clickedInsideItem && !clickedDeleteSlideBtn) {

          document.querySelectorAll('.wishlist-item').forEach(item => {

            const deleteSlide = item.querySelector('.delete-slide');
            const productLinks = item.querySelectorAll('a');
            const xBtn = item.querySelector('.delete-btn-x');

            if (deleteSlide && deleteSlide.style.display === 'block') {

              // Animation inverse (retour vers la droite)
              item.style.transition = 'transform 0.3s ease';
              item.style.transform = '';
              item.style.width = '100%';

              // Masquer le bouton Supprimer
              deleteSlide.style.display = 'none';

              // Réafficher le bouton X
              if (xBtn) xBtn.style.display = 'block';

              // Réactiver les liens
              setTimeout(() => {
                productLinks.forEach(link => {
                  link.style.pointerEvents = '';
                });
              }, 300);
            }

          });

        }

      }, true);



      // Ajout de l'écouteur de clic pour le bouton "Supprimer"
      const deleteBtnsSlide = document.querySelectorAll('.delete-btn-slide');
      deleteBtnsSlide.forEach(btn => {
        btn.addEventListener('click', function(e) {
          const wishlistItem = e.target.closest('.wishlist-item');
          const handle = wishlistItem.dataset.handle; // Récupérer le handle du produit
          log("Produit à supprimer: ", handle); // Log le handle du produit à supprimer

          if (!handle) {
            err("Le handle est indéfini, impossible de supprimer le produit.");
            return; // Quitter si handle est indéfini
          }

          // Afficher la taille de la wishlist avant la suppression
          log(`Wishlist avant suppression: ${wishlist.length} éléments`);

          // Supprimer l'élément du DOM
          wishlistItem.style.transition = 'opacity 0.3s ease';
          wishlistItem.style.opacity = 0;
          setTimeout(() => {
            wishlistItem.remove(); // Supprimer l'élément après l'animation
          }, 300);

          // Retirer l'élément de la wishlist
          wishlist = wishlist.filter(item => item !== handle);
          log("wishlist après suppression: ", wishlist); // Log la wishlist après suppression
          log(`Wishlist après suppression: ${wishlist.length} éléments`);

          // Mise à jour de la wishlist et timestamp
          wishlistUpdatedAt = Date.now();
          window.customerWishlist = wishlist;

          writeLocal(wishlist, wishlistUpdatedAt); // Assurez-vous que l'écriture dans localStorage se fait avant l'envoi de l'événement.
          log('[Wishlist] localStorage mis à jour', { wishlist, updatedAt: wishlistUpdatedAt });

          // Envoi au serveur pour mise à jour
          updateServerWishlist();

          
          // Mettre à jour l'affichage de la wishlist
          syncWishlistButtons();  // Réactualiser les boutons (les icônes)
          updateWishlistBlock();  // Cette fonction mettra à jour l'affichage de la wishlist

          // Synchronisation entre onglets (utiliser `setTimeout` pour permettre la mise à jour avant l'envoi de l'événement)
          setTimeout(() => {
            window.dispatchEvent(new StorageEvent('storage', { key: LS_KEY, newValue: JSON.stringify(wishlist) }));
            log('[Wishlist] Synchronisation avec les autres onglets - Envoi de la wishlist', wishlist);
          }, 300);  // Petit délai de 100ms pour garantir la mise à jour de localStorage avant l'envoi

        });
      });

      

    });
  }

 
  // Fonction de gestion du swipe mobile
  /*function addMobileDeleteSwipe() {
    const wishlistItems = document.querySelectorAll('.wishlist-item');

    wishlistItems.forEach(item => {
      let touchStartX = 0;
      let touchMoveX = 0;
      let touchStartTime = 0;
      const deleteBtn = item.querySelector('.delete-btn-slide'); // Bouton "Supprimer"
      const deleteSlide = item.querySelector('.delete-slide'); // Le container du bouton "Supprimer"

      // Récupérer l'élément c-account__card-content à l'intérieur de wishlist-block-content
      const wishlistBlockContent = document.getElementById('wishlist-block-content');
      const accountCardContent = wishlistBlockContent.querySelector('.c-account__card-content'); // Cibler spécifiquement celui à l'intérieur de wishlist-block-content

      // Détection du swipe uniquement sur mobile
      if (window.matchMedia("(max-width: 970px)").matches) {
        console.log("Swipe détecté sur mobile : Initialisation du swipe pour wishlist-item");

        // Empêcher le scroll horizontal de la page pendant le swipe (sur l'axe X), mais autoriser verticalement (Y)
        document.body.style.overflowX = 'hidden'; // Empêche le scroll horizontal
        document.body.style.overflowY = 'auto'; // Permet le scroll vertical
        document.documentElement.style.overflowX = 'hidden'; // Empêche le scroll horizontal sur html également
        wishlistBlockContent.style.overflowX = 'hidden'; // Empêche le scroll horizontal sur wishlist-block-content

        // Détection du touchstart (lorsque l'utilisateur touche l'élément)
        item.addEventListener('touchstart', function (e) {
          touchStartX = e.touches[0].clientX;  // Position du doigt au début du touch
          touchStartTime = Date.now();
          console.log('touchstart détecté : ', touchStartX);  // Log pour vérifier touchstart
        });

        // Détection du touchmove (lorsque l'utilisateur glisse)
        item.addEventListener('touchmove', function (e) {
          touchMoveX = e.touches[0].clientX;  // Position actuelle du doigt
          console.log('touchmove détecté : ', touchMoveX);  // Log pour vérifier touchmove

          // Si l'utilisateur glisse vers la gauche (pour afficher le bouton "Supprimer")
          if (touchStartX - touchMoveX > 150) {  // Le seuil est de 150px pour un swipe vers la gauche
            console.log('Swipe détecté vers la gauche : Début du slide');
            deleteSlide.style.display = 'block';  // Affiche le bouton "Supprimer"
            item.style.transform = 'translateX(-5%)';  // Déplace l'élément vers la gauche
            item.style.width = '108%';

            // Empêche d'interagir avec d'autres liens pendant l'animation
            const productLinks = item.querySelectorAll('a');
            productLinks.forEach(link => {
              link.style.pointerEvents = 'none';
            });

            wishlistBlockContent.style.overflowX = 'hidden';
          }

          // Si l'utilisateur glisse vers la droite (swipe inverse)
          if (touchMoveX - touchStartX > 150 && deleteSlide.style.display === 'block') {
            console.log('Swipe inversé détecté vers la droite : Retour du slide');

            // Réinitialisation de l'élément vers la position initiale
            deleteSlide.style.display = 'none';  // Masque le bouton "Supprimer"
            item.style.transform = '';  // Retour à la position initiale
            item.style.width = '100%';

            // Réactive les liens
            const productLinks = item.querySelectorAll('a');
            productLinks.forEach(link => {
              link.style.pointerEvents = '';
            });

            wishlistBlockContent.style.overflowX = ''; // Réactive le scroll horizontal sur wishlist-block-content
          }
        });

        // Lors de la fin du swipe, réactive le scroll
        item.addEventListener('transitionend', function () {
          document.body.style.overflowX = ''; // Réactive le scroll horizontal
          document.body.style.overflowY = ''; // Réactive le scroll vertical
          document.documentElement.style.overflowX = '';
          wishlistBlockContent.style.overflowX = ''; // Réactive le scroll horizontal sur wishlist-block-content
        });
      }
    });
  }





  
  // Initialisation spécifique à mobile
  async function initWishlistMobile() {
    if (window.matchMedia("(max-width: 970px)").matches) {
      addMobileDeleteSwipe(); // Ajoute la gestion du swipe pour mobile
    }
  }*/


  // --- toggle produit ---
  async function toggleWishlist(btn) {
    safe(async () => {
      const handle = btn?.dataset?.handle;
      if (!handle) return;

      wishlist = wishlist.includes(handle)
        ? wishlist.filter(h => h !== handle)
        : [...wishlist, handle];

      wishlistUpdatedAt = Date.now();
      window.customerWishlist = wishlist;
      writeLocal(wishlist, wishlistUpdatedAt);
      updateButtonIcon(btn);
      updateButtonText(btn);
      updateWishlistBlock();

      if (window.isCustomerLoggedIn) {
        if (!window.customerEmail) {
          warn('[Wishlist] Email client manquant → impossible de sync serveur');
          return;
        }
        try {
          log('[Wishlist] Envoi vers serveur Vercel :', { email: window.customerEmail, handles: wishlist, updated_at: wishlistUpdatedAt });
          const resp = await fetch("https://wishlist-backend-cyan.vercel.app/api/wishlist", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              email: window.customerEmail,
              handles: wishlist,
              updated_at: wishlistUpdatedAt
            })
          });
          const json = await resp.json();
          if (json.ok) log("[Wishlist] Serveur Vercel → Shopify MAJ OK ✔️");
          else warn("[Wishlist] Erreur serveur :", json);
        } catch (e) {
          err("[Wishlist] Impossible d'appeler Vercel :", e);
        }
      }

      window.dispatchEvent(new StorageEvent('storage', { key: LS_KEY, newValue: JSON.stringify(wishlist) }));
    });
  }
  

  function initClickHandler() {
    document.body.addEventListener('click', e => {
      const btn = e.target.closest && e.target.closest('.wishlist-button');
      if (!btn) return;
      try { e.preventDefault(); } catch(e){}
      toggleWishlist(btn);
    }, { passive:false });
  }

  // --- sync inter-tabs ---
  window.addEventListener('storage', e => {
    if (e.key === LS_KEY && e.newValue) {
      wishlist = JSON.parse(e.newValue);
      window.customerWishlist = wishlist;
      syncWishlistButtons();
      updateWishlistBlock();
      log('[Wishlist] Événement Storage capturé - Wishlist mise à jour dans un autre onglet', wishlist);

    }
  });

  // --- init ---
  let inited = false;
  async function initWishlist() {
    if (inited) return;
    if (typeof window.isCustomerLoggedIn !== 'undefined' && !window.isCustomerLoggedIn) return;

    // ⚡ sync serveur/local
    await syncWishlist();

    initClickHandler();

    // Initialisation spécifique mobile
    //initWishlistMobile();  // Assurez-vous d'initialiser aussi pour mobile

    const observer = new MutationObserver(syncWishlistButtons);
    observer.observe(document.body, { childList:true, subtree:true });

    inited = true;
    log('Wishlist initialisée avec sync multi-device');
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initWishlist();
  } else {
    document.addEventListener('DOMContentLoaded', initWishlist);
    window.addEventListener('load', initWishlist);
  }


  // Après avoir mis à jour le localStorage avec la wishlist sans le produit supprimé :
  async function updateServerWishlist() {
      if (!window.isCustomerLoggedIn) return;
      if (!window.customerEmail) {
          warn('[Wishlist] Email client manquant → impossible de sync serveur');
          return;
      }
      try {
          log('[Wishlist] Envoi vers serveur Vercel pour mise à jour :', { email: window.customerEmail, handles: wishlist, updated_at: wishlistUpdatedAt });
          const resp = await fetch("https://wishlist-backend-cyan.vercel.app/api/wishlist", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                  email: window.customerEmail,
                  handles: wishlist,
                  updated_at: wishlistUpdatedAt
              })
          });
          const json = await resp.json();
          if (json.ok) {
              log("[Wishlist] Serveur Vercel → Mise à jour OK ✔️");
          } else {
              warn("[Wishlist] Erreur serveur :", json);
          }
      } catch (e) {
          err("[Wishlist] Impossible d'appeler Vercel :", e);
      }
  }


})();
